import { render, staticRenderFns } from "./document-center-body.vue?vue&type=template&id=29d2fc1f&scoped=true&"
import script from "./document-center-body.vue?vue&type=script&lang=js&"
export * from "./document-center-body.vue?vue&type=script&lang=js&"
import style0 from "./document-center-body.vue?vue&type=style&index=0&id=29d2fc1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d2fc1f",
  null
  
)

export default component.exports